import { Link } from 'react-router-dom'

export function Channels() {
  return (
    <div className="page">
      <h1 className="section-title">通道对接</h1>
      <p className="lead" style={{ marginBottom: '2rem' }}>
        Telegram、WhatsApp、飞书、Discord、Slack、终端 TUI 等专题配置。
      </p>

      <div className="card">
        <h2>飞书 (Feishu)</h2>
        <p>部署飞书官方插件：配置长链接、申请飞书 <code>im:message</code> 等机器人权限，使用 <code>/feishu start</code> 唤醒。推荐搭配国内模型（Kimi / DeepSeek）获得最佳中文与低成本体验。详见 <Link to="/guides/enterprise">企业协同指南</Link>。</p>
      </div>

      <div className="card">
        <h2>Telegram / Discord / Slack / WhatsApp</h2>
        <p>在 <code>openclaw.json</code> 中配置对应 channel 与 token。WhatsApp 需注意扫码与心跳；若掉线可配合 <code>caffeinate</code>（Mac）保持唤醒。排障见「安全与排障」→ 通道掉线。</p>
      </div>

      <div className="card">
        <h2>终端 TUI</h2>
        <p>本地直接运行 <code>openclaw start</code> 进入 TUI 模式，无需额外通道配置，适合开发与调试。</p>
      </div>
    </div>
  )
}
